import translations from "../assets/locals/translations";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import Axios from "axios";
import { useNavigate } from "react-router-dom";
import AlertDeleteModal from "../components/AlertDelete/AlertDeleteModal";
import PersistentDataGrid from "../components/table/PersistentDataGrid";
import { GridToolbar } from "@mui/x-data-grid";
import { usePaginationState } from "../hooks/usePaginationState";
import Checkbox from "@mui/material/Checkbox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import { Tooltip } from "@mui/material";
import { setShowMessage } from "../redux/slices/notificationSlice";
import moment from "moment";

const Offers = () => {
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const [paginationModel, handlePaginationModelChange] = usePaginationState('offersPaginationState', { pageSize: 50, page: 0 });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const redirectModal = () => {
    navigate("/administration/configuration");
  };
  const [holidayColumnShowHideModel, setHolidayColumnShowHideModel] = useState(
    {}
  );
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [offerlist, setOfferList] = useState([]);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const handleHeaderCheckboxClick = () => {
    setSelectAll(!selectAll);
  };

  const getOfferList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-offer-list`;
      const token = localStorage.getItem("rbacToken");
      const config = {
        headers: {
          token: token,
        },
      };

      const response = await Axios.get(url, config);

      if (response.data?.isSuccess) {
        console.log(response.data.result, "response.data.result");
        setOfferList(response.data.result);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    getOfferList();
  }, []);
  useEffect(() => {
    console.log(offerlist, "offerlist");
    const rowsData = offerlist.map((item, index) => ({
      ...item,
      rowNumber: item.id,
      checkbox: selectAll,
    }));
    setRowData(rowsData);
  }, [offerlist, selectAll]);

  const handleChildCheckboxClick = (itemId) => {
    const updatedRowsData = rowData.map((row) => {
      if (row.id == itemId) {
        return {
          ...row,
          checkbox: !row.checkbox,
        };
      }
      return row;
    });
    setRowData(updatedRowsData);
  };
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const addOffer = () => {
    navigate("/administration/configuration/offer/add");
  };

  const formattedOffer = (offer) => {
    let content = "";
    let file = null;

    try {
      const parsedMessages = JSON.parse(offer.message);

      parsedMessages.forEach((item) => {
        if (item.contentType === "string" && typeof item.content === "string") {
          content = item.content;
        } else if (item.contentType === "MessageMedia") {
          file = item.content;
        }
      });
    } catch (err) {
      console.error("Error parsing offer.message:", err);
    }

    return {
      id: offer.id,
      name: offer.offer_name,
      startDate: moment(offer.offer_start_date).format("YYYY-MM-DD"),
      endDate: moment(offer.offer_end_date).format("YYYY-MM-DD"),
      content,
      attachmentUrl: file ? file.originalname : null,
    };
  };

  const editOffersCell = (data) => {
    const offer = formattedOffer(data);
    navigate("/administration/configuration/offer/edit", {
      state: { data: offer },
    });
  };

  const deleteActionCall = (data) => {
    setType("offer_delete");
    setId(data.id);
    setDeleteMessage(
      `${t.areyousuredeleteoffer || `${t.areyousuredelete || 'Are You Sure You Want To Delete The'} offer`} '${data.offer_name}'?`
    );
    setDisplayConfirmationModal(true);
  };

  const submitDelete = async (e, id) => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/delete-offer/${id}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      const response = await Axios.get(url, config);
      if (response.data && response.data.isSuccess) {
        dispatch(setShowMessage(t.offerdeleted || "Offer Deleted"));
        setDisplayConfirmationModal(false);
      } else {
        console.log("Failed to delete");
        dispatch(setShowMessage(t.failedtodelete || "Failed to delete"));
      }
      getOfferList();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleHolidayColumnShowHideChange = (holiday_newShowHideModel) => {
    setHolidayColumnShowHideModel(holiday_newShowHideModel);
    localStorage.setItem(
      "holiday_columnShowHide",
      JSON.stringify(holiday_newShowHideModel)
    );
  };

  const toggleActiveStatus = async (row) => {
    const id = row.id;
    const is_active = row.is_active;
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/updatestatus-offer/${id}/${is_active}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      const response = await Axios.get(url, config);
      if (response.data && response.data.isSuccess) {
        dispatch(setShowMessage(t.statusupdated || "Status Updated"));
        setDisplayConfirmationModal(false);
      } else {
        console.log("Failed to update");
        dispatch(setShowMessage(t.failedupdate || "Failed to update status"));
      }
      getOfferList();
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: (
        <Checkbox
          {...label}
          checked={selectAll}
          onClick={handleHeaderCheckboxClick}
        />
      ),
      minWidth: 90,
      renderCell: (params) => (
        <Checkbox
          {...label}
          checked={params.row.checkbox}
          onClick={() => handleChildCheckboxClick(params.row.id)}
        />
      ),
    },
    {
      field: "offer_name",
      headerAlign: "left",
      align: "left",
      headerName: translations[currentLanguage].offername,
      minWidth: 120,
      flex: 1,
      valueGetter: (params) =>
        params.row.offer_name ? params.row.offer_name : "-",
    },
    {
      field: "offer_start_date",
      headerAlign: "left",
      align: "left",
      headerName: translations[currentLanguage].startdate || "Start Date",
      minWidth: 120,
      flex: 1,
      valueGetter: (params) => {
        const date = params.row.offer_start_date;
        return date ? moment(date).format("DD/MM/YYYY") : "-";
      },
    },
    {
      field: "offer_end_date",
      headerAlign: "left",
      align: "left",
      headerName: translations[currentLanguage].enddate || "End Date",
      minWidth: 120,
      flex: 1,
      valueGetter: (params) => {
        const date = params.row.offer_end_date;
        return date ? moment(date).format("DD/MM/YYYY") : "-";
      },
    },
    {
      field: "is_active",
      headerName: translations[currentLanguage].isactive,
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: (params) => {
        const isActive =
          params.row.is_active === 1 || params.row.is_active === true;

        return (
          <button
            className={`btn btn-sm m-1 ${isActive ? "text-success" : "text-danger"
              }`}
            style={{
              backgroundColor: isActive ? "#d4edda" : "#f8d7da", // light green / light red
            }}
            onClick={() => toggleActiveStatus(params.row)}
          >
            {isActive ? (t.active || "Active") : (t.inactive || "Inactive")}
          </button>
        );
      },
    },
    {
      field: "menu",
      headerName: (
        <FontAwesomeIcon icon={faEllipsisV} style={{ marginRight: "15px" }} />
      ),
      className: "bg-dark",
      sortable: false,
      filterable: false,
      headerAlign: "right",
      align: "right",
      disableColumnMenu: true,
      width: 130,
      // flex: 1,
      position: "sticky",
      renderCell: (params) => (
        <div className="d-flex justify-content-center dotHoverempicon ">
          <FontAwesomeIcon icon={faEllipsisV} />
          <div className="expandDiv">
            <Tooltip title={translations[currentLanguage].edit}>
              <button
                className="myActionBtn m-1"
                onClick={() => {
                  editOffersCell(params.row);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </button>
            </Tooltip>
            <Tooltip title={translations[currentLanguage].delete}>
              <button
                onClick={() => {
                  deleteActionCall(params.row);
                }}
                className="myActionBtn m-1"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  className="bi bi-trash3"
                  viewBox="0 0 16 16"
                >
                  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                </svg>
              </button>
            </Tooltip>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="bg-white rounded">
      <div className="d-flex align-items-end justify-content-end">
        <div className="d-flex align-items-center my-1" type="button">
          <h6 className="m-0">
            <button
              type="button"
              className="btn btn-primary"
              onClick={addOffer}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-plus-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
              </svg>
              &nbsp; {translations[currentLanguage].addoffer}
            </button>
          </h6>
          <Button
            variant="btn btn-warning mx-1"
            style={{
              width: "75px",
              height: "40px",
              fontSize: "14px",
              borderRadius: "20px",
            }}
            onClick={() => {
              redirectModal();
            }}
          >
            {translations[currentLanguage].back}
          </Button>
        </div>
      </div>
      <div className="tableMenuHover" style={{ height: "85vh", width: "100%" }}>
        <PersistentDataGrid
          rows={rowData}
          columns={columns}
          columnVisibilityModel={holidayColumnShowHideModel}
          onColumnVisibilityModelChange={handleHolidayColumnShowHideChange}
          getRowId={(params) => {
            return params.id;
          }}
          className="rounded"
          style={{
            fontFamily: "Poppins",
            padding: 5,
            backgroundColor: "white",
          }}
          pagination
          paginationMode="client"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          pageSizeOptions={[5, 10, 25, 50]}
          components={{
            Toolbar: GridToolbar,
            NoRowsOverlay: () => (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <span>{t.noUsersBranch || 'There is no Users with current branch'}</span>
              </div>
            ),
          }}
          componentsProps={{
            toolbar: {
              position: "right",
              style: { fontFamily: "Poppins", alignSelf: "end" },
            },
          }}
          rowSelection={false}
          autoPageSize={false}
        />
      </div>
      <AlertDeleteModal
        showModal={displayConfirmationModal}
        hideModal={hideConfirmationModal}
        confirmModal={submitDelete}
        type={type}
        id={id}
        message={deleteMessage}
      />
    </div>
  );
};

export default Offers;
